import { modalService } from '../modal-service';
var AjaxInterceptor = require('../ajax-interceptor');

function initErrorHandlerInterceptor() {
  AjaxInterceptor.addResponseCallback(function(xhr) {
    if (isResponseIgnored(xhr)) {
      return;
    }
    if (xhr.status === 555) {
      handleWAFError(xhr);
    } else if (xhr.status >= 500) {
      handleServerError(xhr);
    } else if (xhr.status === 403) {
      handleForbidden();
    } else if (xhr.status === 401) {
      handleUnauthorized();
    } else if (xhr.status === 0 && xhr.__zone_symbol__xhrTask._state !== 'canceling') {
      handleNoResponse(xhr);
    }
  });
}

function handleNoResponse(xhr) {
  var title = 'Something Went Wrong In Your Browser';
  let machineLocation = window.MachineLocation;
  let machineNumber = window.MachineNumber;
  let url = xhr.__zone_symbol__xhrURL;

  //Avoid displaying the error for walkme until it is whitelisted
  //It could cause issues with automation tests otherwise
  if (url.includes('walkme') || url.includes('google')){
    return;
  }

  //Avoid displaying the error for Heap Analytics until it is whitelisted
  //It could cause issues with automation tests otherwise
  if (url.includes('heapanalytics') || url.includes('auryc')){
    return;
  }
  
  //Avoid displaying the error for ZenDesk until it is whitelisted
  //It could cause issues with automation tests otherwise
  if (url.includes('zdassets')){
    return;
  }

  let errorInfo = btoa(
    `Url: '${url}' (${machineLocation}-${machineNumber}).No data was received. Ready State: '${xhr.readyState}' Status Text:'${xhr.statusText}'.`
  );
  let errorMessage = `Please contact Venue Client Services at 1-888-773-8379 or by email at VenueClientServices@dfinsolutions.com.<br/>The error has been logged with the reference code noted below. Please use this reference number if you contact support.<br/><br/>${errorInfo}<br/><br/>Click the Ok button to close the modal dialog.`;
  var modal = modalService.show({
    title: title,
    body: errorMessage,
    buttons:
      '<a class="btn" id="modal-something-went-wrong-copy-btn">Copy</a> <button class="btn" id="modal-something-went-wrong-close-btn">Ok</button>'
  });

  let appError = new CustomEvent('ai-customevent', {
    detail: {
      name: 'CORSException',
      target: 'target',
      properties: {
        url: url,
        machine: `${machineLocation}-${machineNumber}`
      }
    }
  });
  window.dispatchEvent(appError);

  document.getElementById('modal-something-went-wrong-close-btn').addEventListener('click', function() {
    if (modal) {
      modal.close();
    }
  });
  document.getElementById('modal-something-went-wrong-copy-btn').addEventListener('click', async () => {
    await navigator.clipboard.writeText(errorInfo);
  });
}

function handleWAFError(xhr) {
  const title = 'Something Went Wrong';
  let machineLocation = window.MachineLocation;
  let machineNumber = window.MachineNumber;
  let userIPAddress = window.UserIPAddress;
  let url = xhr.__zone_symbol__xhrURL;
  let caseId = '';
  
  try {
    const regexpCaseId = /_event_transid=\'(?<caseId>.+)\'/;
    const responseText = String(xhr.response);
    const match = responseText.match(regexpCaseId);
    caseId = match?.groups?.caseId ?? '-1';
  } catch (err) {}
  let errorInfo = `WAF Error. Url: '${url}' (${machineLocation}-${machineNumber}). CaseId: '${caseId}' Ready State:'${xhr.readyState}' ClientIp: '${userIPAddress}'.`;

  let appError = new CustomEvent('ai-customevent', {
    detail: {
      name: 'WAFException',
      target: 'target',
      properties: {
        url: url,
        caseId: caseId,
        userIPAddress: userIPAddress,
        machine: `${machineLocation}-${machineNumber}`
      }
    }
  });
  window.dispatchEvent(appError);

  let errorMessage = `Please contact Venue Client Services at 1-888-773-8379 or by email at VenueClientServices@dfinsolutions.com.<br/>The error has been logged with the reference code noted below. Please use this reference number if you contact support.<br/><br/>${btoa(errorInfo)}<br/><br/>Click the Ok button to close the modal dialog.`;
  let modal = modalService.show({
    title: title,
    body: errorMessage,
    buttons:
      '<a class="btn" id="modal-something-went-wrong-copy-btn">Copy</a> <button class="btn" id="modal-something-went-wrong-close-btn">Ok</button>'
  });

  document.getElementById('modal-something-went-wrong-close-btn').addEventListener('click', function() {
    if (modal) {
      modal.close();
    }
  });
  document.getElementById('modal-something-went-wrong-copy-btn').addEventListener('click', async () => {
    await navigator.clipboard.writeText(errorInfo);
  });
}

function handleUnauthorized() {
  
  if (url.includes('heapanalytics') || url.includes('auryc')){
    return;
  }

  location.href = '/RRDCommon/SignOut.aspx';
}

function handleForbidden() {
  var title = 'Forbidden';
  var modalTemplate = `Access Denied. You don't have permission to access`;

  var modal = modalService.show({
    title: title,
    body: modalTemplate,
    buttons: '<button class="btn" id="modal-forbidden-ok-btn">Ok</button>'
  });
  document.getElementById('modal-forbidden-ok-btn').addEventListener('click', function() {
    modal.close();
  });
}

function handleServerError(xhr) {
  let response = null;
  try {
    response = JSON.parse(xhr.response);
  } catch (err) {}
  var title = 'Unexpected application error occurred.';
  var modalTemplate =
    response && response.error && response.error.id
      ? `
            <div>Please contact Venue Client Services at 1-888-773-8379 or by email at VenueClientServices@dfinsolutions.com.</div>
            <div>The error has been logged with the reference number noted below. Please use this reference number if you contact support.</div>
            <span>${response.error.id}</span> <span>${response.error.machineName}</span>
            <div>Click the OK button to close the modal dialog.</div>
            `
      : `
      <div>Please contact Venue Client Services at 1-888-773-8379 or by email at VenueClientServices@dfinsolutions.com.</div>
      <div>Click the OK button to close the modal dialog.</div>`;
  var modal = modalService.show({
    title: title,
    body: modalTemplate,
    buttons: '<button class="btn" id="modal-error-ok-btn">Ok</button>'
  });

  document.getElementById('modal-error-ok-btn').addEventListener('click', function() {
    modal.close();
  });
}

function isResponseIgnored(xhr) {
  return (
    (xhr.requestHeaders &&
      xhr.requestHeaders['spa-ignore-error-handler'] &&
      xhr.requestHeaders['spa-ignore-error-handler'][0] === 'true') ||
    xhr.responseURL.includes('/appinsights/events')
  );
}

export { initErrorHandlerInterceptor };
